module.exports = __webpack_public_path__ + "static/img/img19.19bd941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img19.png
// module id = eVSR
// module chunks = 0